export default __webpack_public_path__ + "static/media/rocks-08.f4189446.png";